<section class="container-fluid">
  <div class="tab-content">
    <div class="row mb-5">
      <div class="col-md-8">
        <div class="d-flex">
          @for (type of InvestmentType | enumToArray; track type) {
            @if (implementedInvestmentTypes.includes(type.key)) {
              <div
                class="type-select"
                [class.active]="type.key == selectedType"
                (click)="changeTab(type.key)"
              >
                {{ type.value }}
              </div>
            }
          }
        </div>
      </div>
      <div class="col-md-4 text-primary my-application font-weight-bold d-flex align-items-center">
        <span class="cursor-pointer" routerLink="/raise/my-application">
          {{ 'raise.myApplications' | translate }}
        </span>
        <div
          class="pitchin-icon pitchin-icon-next-arrow ml-3"
          routerLink="/raise/my-application"
        ></div>
      </div>
    </div>
    @if (selectedType == InvestmentType.ECF) {
      @if (isLoading) {
        <agmo-loading></agmo-loading>
      }
      @if (!isLoading && campaigns.length == 0) {
        <div class="row justify-content-center no-campaign">
          <div class="col-lg-4 col-md-6 text-center">
            <img
              class="w-50"
              alt="Empty Placeholder"
              src="../../../assets/img/brand/mycampaign_ecf_placeholder_1@2x.png"
            />
            <div
              class="my-3 font-size-larger"
              [innerHTML]="'raise.raiseBusinessAndGrow' | translate"
            ></div>
            <div class="btn btn-primary-border btn-learn-more" routerLink="/raise">
              {{ 'common.learnMore' | translate }}
            </div>
          </div>
        </div>
      }
      <div class="row">
        @for (campaign of campaigns; track campaign) {
          <div class="col-lg-4 col-md-6">
            <div class="campaign">
              <div class="action-panel">
                @if (campaign.campaignStatus) {
                  <div
                    class="campaign-status"
                    [class.success]="campaign.campaignStatus == CampaignStatus.Success"
                    [class.live]="
                      [CampaignStatus.PreLive, CampaignStatus.Live].includes(
                        campaign.campaignStatus
                      )
                    "
                    [class.cooling-off]="campaign.campaignStatus == CampaignStatus.Cooling"
                    [class.fail]="
                      [
                        CampaignStatus.Fail,
                        CampaignStatus.Rejected,
                        CampaignStatus.NotApplicable,
                      ].includes(campaign.campaignStatus)
                    "
                    [class.in-progress]="
                      [CampaignStatus.InProcess, CampaignStatus.New].includes(
                        campaign.campaignStatus
                      )
                    "
                    [class.share-allotment]="
                      [CampaignStatus.ShareAllotment].includes(campaign.campaignStatus)
                    "
                  >
                    {{ 'campaign.' + CampaignStatus[campaign.campaignStatus] | translate }}
                  </div>
                }
                <div class="action" ngbDropdown placement="bottom-right">
                  @if (
                    [
                      CampaignStatus.PreLive,
                      CampaignStatus.Live,
                      CampaignStatus.Success,
                      CampaignStatus.Fail,
                      CampaignStatus.Cooling,
                      CampaignStatus.ShareAllotment,
                    ].includes(campaign.campaignStatus)
                  ) {
                    <div class="pitchin-icon pitchin-icon-more no-caret" ngbDropdownToggle></div>
                  }
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div
                      class="dropdown-item font-size-regular font-weight-bold"
                      [routerLink]="['/equity', campaign.slug]"
                    >
                      {{ 'investment.campaignPage' | translate }}
                    </div>
                    @if (isenable) {
                      <div
                        class="dropdown-item font-size-regular font-weight-bold"
                        [routerLink]="['investor-management', campaign.slug]"
                      >
                        {{ 'investment.investorList' | translate }}
                      </div>
                    }
                    @if (!isenable) {
                      <div
                        class="dropdown-item font-size-regular font-weight-bold"
                        [routerLink]="['investor-list', campaign.slug]"
                      >
                        {{ 'investment.investorList' | translate }}
                      </div>
                    }
                    @if (
                      [CampaignStatus.PreLive, CampaignStatus.Live].includes(
                        campaign.campaignStatus
                      )
                    ) {
                      @if (
                        !campaign.campaignDetailApprovalStatus ||
                        ![
                          CampaignDetailApprovalStatus.Pending,
                          CampaignDetailApprovalStatus.Rejected,
                        ].includes(campaign.campaignDetailApprovalStatus)
                      ) {
                        <div
                          class="dropdown-item font-size-regular font-weight-bold d-flex"
                          [routerLink]="['edit-campaign/campaign', campaign.id]"
                        >
                          {{ 'investment.editCampaign' | translate }}
                          @if (
                            campaign.campaignDetailApprovalStatus ==
                            CampaignDetailApprovalStatus.Draft
                          ) {
                            <div class="custom-badge blue-background ml-2">
                              {{ 'raise.Draft' | translate }}
                            </div>
                          }
                        </div>
                      }
                      @if (
                        campaign.campaignDetailApprovalStatus ==
                        CampaignDetailApprovalStatus.Pending
                      ) {
                        <div
                          class="dropdown-item font-size-regular font-weight-bold d-flex"
                          [routerLink]="'campaign-draft/' + campaign.id"
                        >
                          {{ 'investment.viewDraft' | translate }}
                          <div class="custom-badge yellow-background ml-2">
                            {{ 'ekyc.Pending' | translate }}
                          </div>
                        </div>
                      }
                      @if (
                        campaign.campaignDetailApprovalStatus ==
                        CampaignDetailApprovalStatus.Rejected
                      ) {
                        <div
                          class="dropdown-item font-size-regular font-weight-bold d-flex"
                          [routerLink]="[
                            'campaign-draft-reject',
                            campaign.fundRaiseApplicationId,
                            campaign.id,
                          ]"
                        >
                          {{ 'investment.editCampaign' | translate }}
                          <div class="custom-badge red-background ml-2">
                            {{ 'raise.Rejected' | translate }}
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="d-flex mb-3">
                <img
                  class="logo-image"
                  [alt]="campaign.name"
                  [src]="campaign.company?.companyLogoUrl || defaultLogo"
                />
              </div>
              <div class="d-flex mb-3">
                <div class="campaign-title text-break">{{ campaign.name }}</div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.investmentAmount' | translate }}
                  </div>
                  <div class="campaign-amount larger-text text-green">
                    {{ (campaign.totalInventmentAmount | numberSuffix) || '-' }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.investorsNo' | translate }}
                  </div>
                  <div class="campaign-amount larger-text text-green">
                    {{ campaign.investorCount }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.awaitingPayment' | translate }}
                  </div>
                  <div class="campaign-amount larger-text text-green">
                    {{ (campaign.fundedAmount | numberSuffix) || '-' }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.investorsNo' | translate }}
                  </div>
                  <div class="campaign-amount larger-text text-green">
                    {{ campaign.pledgedInvestorCount }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.largestInvestmentAmount' | translate }}
                  </div>
                  <div class="campaign-amount text-green">
                    {{ (campaign.largestInvestmentAmount | numberSuffix) || '-' }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="campaign-label">
                    {{ 'campaign.lastInvestmentAmount' | translate }}
                  </div>
                  <div class="campaign-amount text-green">
                    {{ (campaign.lastPaidAmount | numberSuffix) || '-' }}
                  </div>
                </div>
                <div class="col-12">
                  <div class="campaign-progress">
                    {{ campaign.raisedPercentage | number: '1.2-2' }}% -
                    {{
                      ((campaign.endAt | amDifference: today : 'days') > 0
                        ? (campaign.endAt | amDifference: today : 'days' : true)
                        : 0
                      ) | number: '1.0-0'
                    }}
                    {{ 'campaign.daysLeft' | translate }}
                  </div>
                  <div class="campaign-progress-bar">
                    <mat-progress-bar
                      mode="determinate"
                      height="10"
                      [value]="campaign.raisedPercentage"
                      [color]="campaign.raisedPercentage > 100 ? 'success' : ''"
                    >
                    </mat-progress-bar>
                  </div>
                </div>
              </div>
              @if (campaign.showDetails) {
                <div class="row border-top pt-4">
                  <div class="col-md-6 mb-3">
                    <div class="campaign-label">
                      {{ 'campaign.minTargetAmount' | translate }}
                    </div>
                    <div class="campaign-amount text-black">
                      {{ (campaign.minimumTargetAmount | numberSuffix) || '-' }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="campaign-label">
                      {{ 'campaign.maxTargetAmount' | translate }}
                    </div>
                    <div class="campaign-amount text-black">
                      {{ (campaign.maximumTargetAmount | numberSuffix) || '-' }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="campaign-label">
                      {{ 'campaign.overSubscriptionAmount' | translate }}
                    </div>
                    <div class="campaign-amount text-black">
                      {{ (campaign.overSubscriptionAmount | numberSuffix) || '-' }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="campaign-label">
                      {{ 'campaign.minAmountForAPledge' | translate }}
                    </div>
                    <div class="campaign-amount text-black">
                      {{
                        (campaign.minimumLots * campaign.sharePerLot * campaign.pricePerShare
                          | numberSuffix) || '-'
                      }}
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="campaign-label">
                      {{ 'campaign.eachInvestmentLot' | translate }}
                    </div>
                    <div class="campaign-amount text-black">
                      {{ (campaign.sharePerLot * campaign.pricePerShare | numberSuffix) || '-' }}
                    </div>
                  </div>
                  <div class="col-12 mt-4">
                    @if (campaign.showCampaignData) {
                      <div class="mt-3">
                        <div
                          class="section-title mb-2 font-weight-bold d-flex align-items-center"
                          style="color: rgba(38, 99, 235, 255)"
                        >
                          <i class="fa fa-users me-2"></i>
                          TRAFFIC & CONVERSION
                        </div>
                        <div class="d-flex justify-content-between flex-wrap">
                          <!-- Total Visitors -->
                          <div
                            class="mb-1 pb-2 border-right flex-grow-1 d-flex flex-column justify-content-between tooltip-trigger"
                            style="cursor: pointer; max-width: 30%"
                            (click)="isMobile && toggleTooltip('visitors')"
                          >
                            <div>
                              <div
                                class="text-muted small text-center align-items-center text-nowrap"
                                style="font-size: 0.7rem"
                              >
                                TOTAL VISITORS
                                <!-- Desktop: Chevron -->
                                @if (isMobile) {
                                  <i
                                    class="fa"
                                    [class.fa-chevron-up]="openTooltip === 'visitors'"
                                    [class.fa-chevron-down]="openTooltip !== 'visitors'"
                                    (click)="toggleTooltip('visitors'); $event.stopPropagation()"
                                    style="left: 20px"
                                  ></i>
                                }
                                <!-- Mobile: Info icon -->
                                @if (!isMobile) {
                                  <span class="position-relative">
                                    <img
                                      src="../../../assets/img/icons/common/icons8-info.svg"
                                      class="ms-2 tw-mt-2"
                                      alt="info_outline"
                                      style="
                                        cursor: pointer;
                                        width: 12px;
                                        height: 12px;
                                        vertical-align: middle;
                                        margin-top: -2px;
                                      "
                                      (mouseenter)="showVisitorsTip = true"
                                      (mouseleave)="showVisitorsTip = false"
                                    />
                                    @if (showVisitorsTip) {
                                      <div
                                        class="position-absolute bg-light text-dark p-2 rounded shadow"
                                        style="
                                          top: 20px;
                                          left: 0;
                                          font-size: 0.7rem;
                                          min-width: 150px;
                                          max-width: 280px;
                                          white-space: normal;
                                        "
                                      >
                                        Total Unique Website Visitors
                                      </div>
                                    }
                                  </span>
                                }
                              </div>
                              <!-- Desktop inline help -->
                              @if (isMobile && openTooltip === 'visitors') {
                                <div
                                  class="text-muted small fst-italic text-center"
                                  style="
                                    font-size: 0.75rem;
                                    white-space: normal;
                                    word-wrap: break-word;
                                  "
                                >
                                  Total Unique Website Visitors
                                </div>
                              }
                            </div>
                            <div class="fs-5 fw-bold text-center mt-2">
                              {{ campaign.viewCount || 0 }}
                            </div>
                          </div>
                          <!-- Converted Count -->
                          <div
                            class="mb-1 pb-2 border-right flex-grow-1 d-flex flex-column justify-content-between tooltip-trigger"
                            style="cursor: pointer; max-width: 37%"
                            (click)="isMobile && toggleTooltip('converted')"
                          >
                            <div>
                              <div
                                class="text-muted small text-center align-items-center text-nowrap"
                                style="font-size: 0.7rem"
                              >
                                CONVERTED COUNT
                                <!-- Desktop: Chevron -->
                                @if (isMobile) {
                                  <i
                                    class="fa"
                                    [class.fa-chevron-up]="openTooltip === 'converted'"
                                    [class.fa-chevron-down]="openTooltip !== 'converted'"
                                    (click)="toggleTooltip('converted'); $event.stopPropagation()"
                                    style="left: 20px"
                                  ></i>
                                }
                                <!-- Mobile: Info icon -->
                                @if (!isMobile) {
                                  <span class="position-relative">
                                    <img
                                      src="../../../assets/img/icons/common/icons8-info.svg"
                                      class="ms-2 tw-mt-2"
                                      alt="info_outline"
                                      style="
                                        cursor: pointer;
                                        width: 12px;
                                        height: 12px;
                                        vertical-align: middle;
                                        margin-top: -2px;
                                      "
                                      (mouseenter)="showConvertedTip = true"
                                      (mouseleave)="showConvertedTip = false"
                                    />
                                    @if (showConvertedTip) {
                                      <div
                                        class="position-absolute bg-light text-dark p-2 rounded shadow"
                                        style="
                                          top: 20px;
                                          left: 0;
                                          font-size: 0.7rem;
                                          min-width: 150px;
                                          max-width: 280px;
                                          white-space: normal;
                                        "
                                      >
                                        Completed Paid Investor
                                      </div>
                                    }
                                  </span>
                                }
                              </div>
                              <!-- Desktop inline help -->
                              @if (isMobile && openTooltip === 'converted') {
                                <div
                                  class="text-muted small fst-italic text-center"
                                  style="
                                    font-size: 0.75rem;
                                    white-space: normal;
                                    word-wrap: break-word;
                                  "
                                >
                                  Completed Paid Investor
                                </div>
                              }
                            </div>
                            <div class="fs-5 fw-bold text-center text-success mt-2">
                              {{ campaign.investorCount || 0 }}
                            </div>
                          </div>
                          <!-- Conversion Rate -->
                          <div
                            class="mb-1 pb-2 flex-grow-1 d-flex flex-column justify-content-between tooltip-trigger"
                            style="cursor: pointer; max-width: 32%"
                            (click)="isMobile && toggleTooltip('rate')"
                          >
                            <div>
                              <div
                                class="text-muted small text-center align-items-center text-nowrap"
                                style="font-size: 0.7rem"
                              >
                                CONVERSION RATE
                                <!-- Desktop: Chevron -->
                                @if (isMobile) {
                                  <i
                                    class="fa"
                                    [class.fa-chevron-up]="openTooltip === 'rate'"
                                    [class.fa-chevron-down]="openTooltip !== 'rate'"
                                    (click)="toggleTooltip('rate'); $event.stopPropagation()"
                                    style="left: 20px"
                                  ></i>
                                }
                                <!-- Mobile: Info icon -->
                                @if (!isMobile) {
                                  <span class="position-relative">
                                    <img
                                      src="../../../assets/img/icons/common/icons8-info.svg"
                                      class="ms-2 tw-mt-2"
                                      alt="info_outline"
                                      style="
                                        cursor: pointer;
                                        width: 12px;
                                        height: 12px;
                                        vertical-align: middle;
                                        margin-top: -2px;
                                      "
                                      (mouseenter)="showRateTip = true"
                                      (mouseleave)="showRateTip = false"
                                    />
                                    @if (showRateTip) {
                                      <div
                                        class="position-absolute bg-light text-dark p-2 rounded shadow"
                                        style="
                                          top: 20px;
                                          right: 0;
                                          font-size: 0.7rem;
                                          min-width: 150px;
                                          max-width: 280px;
                                          white-space: normal;
                                        "
                                      >
                                        (Complete Paid Investor / Unique Website Visitor) * 100
                                      </div>
                                    }
                                  </span>
                                }
                              </div>
                              <!-- Desktop inline help -->
                              @if (isMobile && openTooltip === 'rate') {
                                <div
                                  class="text-muted small fst-italic text-center"
                                  style="
                                    font-size: 0.75rem;
                                    white-space: normal;
                                    word-wrap: break-word;
                                  "
                                >
                                  (Complete Paid Investor / Unique Website Visitor) * 100
                                </div>
                              }
                            </div>
                            <div class="fs-5 fw-bold mt-2 text-center" style="color: #276cf5">
                              {{
                                (campaign.viewCount > 0
                                  ? (campaign.investorCount / campaign.viewCount) * 100
                                  : 0
                                ) | number: '1.2-2'
                              }}%
                            </div>
                          </div>
                        </div>
                        <!-- Top 2 Engagement -->
                        <div
                          class="section-title mt-4 font-weight-bold d-flex align-items-center"
                          style="cursor: pointer; color: blueviolet"
                          (click)="isMobile && toggleTooltip('top2')"
                        >
                          <!-- Title -->
                          <i class="fa fa-line-chart me-2"></i>
                          <span>TOP 2 ENGAGEMENT</span>
                          <!-- Desktop: Chevron -->
                          @if (isMobile) {
                            <i
                              class="fa ms-2"
                              [class.fa-chevron-up]="openTooltip === 'top2'"
                              [class.fa-chevron-down]="openTooltip !== 'top2'"
                              (click)="toggleTooltip('top2'); $event.stopPropagation()"
                              style="right: 20px"
                            ></i>
                          }
                          <!-- Mobile info icon -->
                          @if (!isMobile) {
                            <span class="position-relative">
                              <img
                                src="../../../assets/img/icons/common/icons8-info.svg"
                                class="ms-2 tw-ml-1 tw-mt-2"
                                alt="info_outline"
                                style="
                                  cursor: pointer;
                                  width: 12px;
                                  height: 12px;
                                  vertical-align: middle;
                                  margin-top: -2px;
                                "
                                (mouseenter)="showTop2Tip = true"
                                (mouseleave)="showTop2Tip = false"
                              />
                              <!-- Mobile tooltip -->
                              @if (showTop2Tip) {
                                <div
                                  class="position-absolute bg-light text-dark p-2 rounded shadow mobile-tooltip"
                                  style="
                                    top: 20px;
                                    left: 0;
                                    font-size: 0.75rem;
                                    min-width: 200px;
                                    max-width: 300px;
                                    white-space: normal;
                                    z-index: 9999;
                                  "
                                >
                                  Total Unique Website visitor count for the top 2 most-engaged
                                  section
                                </div>
                              }
                            </span>
                          }
                        </div>
                        <!-- Desktop inline help -->
                        @if (isMobile && openTooltip === 'top2') {
                          <div
                            class="text-muted small fst-italic"
                            style="font-size: 0.75rem; white-space: normal; word-wrap: break-word"
                          >
                            Total Unique Website visitor count for the top 2 most-engaged section
                          </div>
                        }
                        <!-- Engagement content -->
                        <div class="row">
                          @for (item of campaign.top2Counts; track item) {
                            <div
                              style="width: 45%"
                              class="mb-3 mt-3 mx-2 border border-gray rounded"
                            >
                              <div
                                class="mt-2 d-flex align-items-center justify-content-between mb-1 px-2"
                              >
                                <!-- left group: dot + label -->
                                <div class="d-flex align-items-center">
                                  <span class="small ml-1" style="color: blueviolet">{{
                                    item.label
                                  }}</span>
                                </div>
                                <!-- right icon -->
                                <i
                                  [class]="item.icon + ' mr-1'"
                                  style="color: blueviolet; font-size: 1rem"
                                ></i>
                              </div>
                              <div class="mb-2 ml-3 ps-2 fs-5 fw-bold">{{ item.value }}</div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="more-details" (click)="showDetails(campaign)">
                {{ 'common.moreDetails' | translate }}
                <i
                  class="fa ml-3"
                  [class.fa-chevron-up]="campaign.showDetails"
                  [class.fa-chevron-down]="!campaign.showDetails"
                ></i>
              </div>
            </div>
          </div>
        }
      </div>
      @if (total > params.take) {
        <div class="row">
          <div class="col-lg-12">
            <div class="paging mt-3">
              <ngb-pagination
                [collectionSize]="total"
                [(pageSize)]="params.take"
                [(page)]="params.currentPage"
                (pageChange)="getList()"
                [maxSize]="5"
                [rotate]="true"
              >
                <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
                <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
                <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
      }
    }
  </div>
</section>
